import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core'
import {
    ElementChoice,
} from '@app/features/shared/components/element-choice-select/element-choice'
import { Observable } from 'rxjs'

@Component({
    selector: 'app-element-choice-select',
    templateUrl: './element-choice-select.component.html',
    styleUrls: ['./element-choice-select.component.sass'],
})
export class ElementChoiceSelectComponent<T> implements OnChanges {

    @Input() canChangeElement!: boolean
    @Input() startingSelection?: ElementChoice<T>
    selectedElement?: ElementChoice<T>
    @Input() elementChoices?: Observable<ElementChoice<T>[]>
    @Input() dataTestId?: string
    @Input() warningText?: string
    @Input() warningValues?: T[] | null
    @Input() warningIconSrc?: string
    @Input() warningIconAlt: string = 'Warning'
    @Input() warningTestId?: string
    showWarning: boolean = false

    @Output()
        loadElements: EventEmitter<T[]> = new EventEmitter<T[]>()
    @Output()
        elementChosen: EventEmitter<T> = new EventEmitter<T>()

    constructor() { }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['startingSelection'] && !this.elementChoices) {
            this.selectedElement = this.startingSelection
        }
        this.updateWarningVisibility()
    }

    loadElementChoices() {
        this.loadElements.emit()
    }

    selectNewElement(target: EventTarget, choices: ElementChoice<T>[]) {
        const selectTarget = target as HTMLSelectElement
        const id = selectTarget.value
        this.selectedElement = choices.find((choice) => choice.id === id)
        this.updateWarningVisibility()
    }

    cancelElementUpdate() {
        this.selectedElement = this.startingSelection
        this.elementChoices = undefined
        this.updateWarningVisibility()
    }

    finishElementUpdate() {
        this.elementChoices = undefined
        this.updateWarningVisibility()
    }

    saveElementUpdate() {
        this.elementChosen.emit(this.selectedElement?.value)
        this.elementChoices = undefined
        this.updateWarningVisibility()
    }

    private updateWarningVisibility(): void {
        if (!this.warningText || !this.warningValues || this.warningValues.length === 0) {
            this.showWarning = false
            return
        }
        if (this.selectedElement === undefined) {
            this.showWarning = false
            return
        }
        this.showWarning = !this.warningValues.some(value => value === this.selectedElement?.value)
    }
}
